<template>
  <div>
    <technicalManage-list v-show="tabType === 1" @handleShow="handleShow" />
    <technicalManage-show v-if="tabType === 2" :rowId="rowId" @handleShow="handleShow"/>
  </div>
</template>

<script>
import technicalManageList from './list.vue'
import technicalManageShow from './show.vue'
export default {
  components: { technicalManageList,technicalManageShow },
  data() {
    return {
      tabType: 1,
      rowId: null,
      technicalState:null
    }
  },
  methods: {
    handleShow(row, type) {
      this.tabType=type
      this.rowId = row
      // this.technicalState = type
    }
  }
}
</script>

<style>
</style>
